import SelectPartnerPage from "./selectPartner"
export default SelectPartnerPage